// extracted by mini-css-extract-plugin
module.exports = {"iconColor":"IconColor_iconColor__LBte0"};